import React from 'react';
import HeatMapDetails from 'components/HeatMapDetails';
import { DEFAULT_HEATMAP } from 'constants/index';
import helpers from 'helpers/proposal';

// .publish-content has padding-top: 114px in editor preview (>= 992px viewport).
// The activity modal heatmap uses padding-top: 0. Shift heatmap break lines (i > 0)
// up by this amount so they appear at the same content position as the editor.
const EDITOR_PUBLISH_PADDING_TOP = 114;

const PageBreakers = ({ sectionHeight, fromActivityModal, heatmaps, screen }) => {
  const numberOfBreaks = Math.ceil(sectionHeight / 1250) || 1;
  // if (!numberOfBreaks) return null;

  let tempHeight = 0;
  const breaksPage = [];

  for (let i = 0; i < numberOfBreaks; i++) {
    const top = fromActivityModal && i > 0 ? tempHeight - EDITOR_PUBLISH_PADDING_TOP : tempHeight;
    breaksPage.push(
      <div
        key={i}
        className={`section-page-breaker above-xl${
          fromActivityModal ? ' activity-modal-page-breaker' : ''
        }`}
        style={{ top: `${top}px` }}>
        {i > 0 && (
          <>
            {!fromActivityModal && <div className="section-page-breaker-sides" />}

            <div
              className="section-page-breaker-center"
              style={{ width: screen === 'mobile' ? '500px' : '900px' }}
            />

            {!fromActivityModal && (
              <div className="section-page-breaker-sides">
                <p>End of {helpers.ordinalSuffixOf(i)} PDF page</p>
              </div>
            )}
          </>
        )}

        {heatmaps && (
          <HeatMapDetails heatMap={heatmaps[i + 1] || { ...DEFAULT_HEATMAP }} pageNumber={i + 1} />
        )}
      </div>
    );

    tempHeight += 1250;
  }

  return <>{breaksPage}</>;
};

export default PageBreakers;
